import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import * as masterSelectors from "../../Store/ANMDetails/ANMDetailsSelectors";
import { fetchANMDetails } from "../../Store/ANMDetails/ANMDetailsActions";
import { transferAnmMappingsService } from "../../Services/AnmDetailsPhcHeadService.js";
import {
  successToastStyle,
  errorToastStyle,
} from "../../Shared/Utils/ToastUtils";
import "./ANMTransferPopup.scss";
import transfer_approved from "../../Assets/Transfer_approved.png";
import vector_img from "../../Assets/Vector.png";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../Layout/ChangeLanguage/LanguageProvider";

const Footer = (
  buttonStyle,
  handleCancel,
  handleTransferClick,
  loading,
  firstname,
  t
) => (
  <div className="p-grid flex p-justify-between justify-content-center gap-5">
    <Button
      label={t("Cancel")}
      style={buttonStyle("#999999", "#FFFFFF", "134px")}
      onClick={handleCancel}
    />
    <Button
      label={t("TransferSubcenters")}
      style={buttonStyle("#fff", "#1D2965", "229px", "16px", 600)}
      onClick={handleTransferClick}
      disabled={loading || !firstname} // Disable the button while loading
    />
  </div>
);

export const ANMTransferPopup = ({ visible, onClose, selectedItems ,typeData}) => {
  const masterData = useSelector(masterSelectors.getANMDetails);
  const [firstname, setfirstname] = useState("");
  const [, setsubcentername] = useState("");
  const [selectedASHA, setSelectedASHA] = useState(null);
  const [transferClicked, setTransferClicked] = useState(false); //23 mar
  const [loading, setLoading] = useState(false); //23 mar

  const [selectedSubcenters, setSelectedSubcenters] = useState([]);
  const { t } = useTranslation("AnmTransferPhc");
  const { selectedLanguageId } = useLanguage();
  const [, setData] = useState([]);
  const dispatch = useDispatch();
  const [, setDistrictCode] = useState("");
  const [, setDistrictName] = useState("");
  const [, setStatus] = useState("");
  const [, setSelectedState] = useState("");

  useEffect(() => {
    setData(masterData);
  }, [masterData]);

  useEffect(() => {
    if (selectedItems?.length) {
      setSelectedASHA(selectedItems[0]);
      dispatch(fetchANMDetails(selectedLanguageId,typeData));
    }
  }, [selectedItems, selectedLanguageId, dispatch,typeData]);
  useEffect(() => {
    setData(masterData);
  }, [masterData]);
  const isASHAMissing = !selectedASHA;
  const isNameMissing = !firstname;
  const areSubcentersMissing = selectedSubcenters.length === 0;
  const handleUpdateAnm = useCallback(async () => {
    if (isASHAMissing || isNameMissing || areSubcentersMissing) {
      console.error("Required fields not selected");
      return;
    }

    await Promise.all(
      selectedSubcenters.map((subcenter) =>
        transferAnmMappingsService(subcenter, selectedASHA.ashaanmid, firstname)
      )
    )
      .then(() => {
        toast.success(t("ANM Registration is approved successfully"), {
          style: {
            ...successToastStyle,
            width: "918px",
            height: "60px",
          },
        });
      })
      .catch(() => {
        toast.error(t("Failed to transfer ANM mappings"), {
          style: {
            ...errorToastStyle,
            width: "918px",
            height: "60px",
          },
        });
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedASHA, firstname, selectedSubcenters]);
  useEffect(() => {
    if (transferClicked && !loading) {
      setLoading(true);
      handleUpdateAnm();
    }
  }, [transferClicked, loading, handleUpdateAnm]);
  const handleTransferClick = () => {
    if (loading) {
      return;
    }
    setTransferClicked(true);
  };
  useEffect(() => {
    setLoading(false);
  }, [selectedItems]);

  const handleCancel = () => {
    toast.error(t("ANM Registration is rejected successfully"), {
      style: {
        ...errorToastStyle,
        width: "918px",
        height: "60px",
      },
    });
  };
  useEffect(() => {
    const hasValidSelectedItems = selectedItems && selectedItems.length > 0;
    const hasValidSubcenterNames =
      hasValidSelectedItems &&
      selectedItems[0].subcenternames &&
      selectedItems[0].subcenternames.length > 0;

    if (hasValidSubcenterNames) {
      const selectedANM = selectedItems[0];
      const subcenterNamesArray = selectedANM.subcenternames;
      const { anmId, firstname, status, mobileNo, subcentername } = selectedItems[0];
      setDistrictCode(anmId || "");
      setDistrictName(firstname || "");
      setStatus(status || "");
      setSelectedState(mobileNo || "");
      setsubcentername(subcentername || "");
      setSelectedSubcenters(subcenterNamesArray);

      const uniqueSubcenterNames = Array.from(new Set(subcenterNamesArray));
      dispatch(
        fetchANMDetails(
          selectedLanguageId,
          selectedANM.firstname,
          selectedANM.lastname,
          selectedANM.subcenternames,
          uniqueSubcenterNames
        )
      );
    }
  }, [selectedItems, selectedLanguageId, dispatch]);

  const onSubcenterChange = (e, subcenterName) => {
    const isChecked = e.checked;

    const updatedSubcenters = isChecked
      ? [...selectedSubcenters, subcenterName]
      : selectedSubcenters.filter((subcenter) => subcenter !== subcenterName);

    setSelectedSubcenters(updatedSubcenters);

    // const action = isChecked ? "selected" : "deselected";
  };
  const filteredANMs = masterData.filter(
    (anm) => selectedASHA && anm.ashaanmid !== selectedASHA.ashaanmid
  );
  const anmOptions = filteredANMs.map((anm) => ({
    label: `${anm.firstname} ${anm.lastname}`,
    value: anm.ashaanmid,
  }));
  const loginModalHeader = () => {
    return (
      <div data-testid="anm-popup" className="anm-popup">
        <div
          className="font-semibold text-xl pt-2 p-3"
          style={{ display: "flex" }}
        >
          <div style={{ marginBottom: "5px" }}>
            <img
              src={transfer_approved}
              alt="Transfer Approved"
              className="mr-2"
              style={{ width: "36px", height: "36px" }}
            />
          </div>
          <div style={{ marginBottom: "5px", marginTop: "4px" }}>
            <span
              style={{
                paddingLeft: "5px",
                color: "#E03581",
                fontWeight: "300",
                fontStyle: "Open Sans",
                marginBottom: "5px",

                marginLeft: "10px",
              }}
            >
              {t("TransferANMMappings")} :
            </span>
          </div>
        </div>
      </div>
    );
  };

  const buttonStyle = (
    color,
    backgroundColor,
    width,
    fontSize = "inherit",
    fontWeight = "inherit"
  ) => ({
    color,
    backgroundColor,
    borderColor: color,
    width,
    height: "40px",
    borderRadius: "8px",
    fontSize,
    fontWeight,
  });

  return (
    <div
      className="s"
      style={{
        backgroundColor: "transparent !important",
        boxShadow: "none !important",
      }}
    >
      <Dialog
        className={`dialog`}
        header={loginModalHeader}
        footer={Footer(
          buttonStyle,
          handleCancel,
          handleTransferClick,
          loading,
          firstname,
          t
        )}
        visible={visible}
        modal={true}
        style={{
          width: "669px",
          height: "499px",
          backgroundColor: "red !important",
          boxShadow: "none !important",
        }}
        onHide={onClose}
        draggable={false}
      >
        <div className="border justify-content-center border-1 rem anm-container rem p-1 mx-3 min-w-min">
          <div className="flex   flex-column flex-wrap flex-1 font-bold  border-round left-30 min-w-min anm-name">
            {t("ANMName")}
            <div className="flex" data-testid="title">
              <InputText
                id="title"
                value={
                  selectedASHA
                    ? selectedASHA.firstname + " " + selectedASHA.lastname
                    : ""
                }
                disabled
                className="input-style"
                data-testid="title-input-test"
              />
            </div>
          </div>

          <div className="flex dialog-small-box border-1 rem p-1 mx-3 min-w-min">
            <div
              className="flex flex-column  font-bold  border-round"
              style={{
                width: "40%",
                height: "100%",
              }}
            >
              <div className="  justify-content-left subcenter-title">
                {t("SelectSubcenter")}
              </div>
              <div
                className="flex  justify-content-left"
                style={{ margin: "0px 0px 10px 10px" }}
              >
                <div className="card flex justify-content-left">
                  <div className="flex flex-column gap-3">
                    {selectedASHA &&
                      selectedASHA.subcenternames &&
                      selectedASHA.subcenternames.map(
                        (subcenterName, index) => (
                          <div
                            key={subcenterName}
                            className="flex align-items-center"
                          >
                            <Checkbox
                              name={`subcenter_${index}`}
                              value={subcenterName}
                              onChange={(e) =>
                                onSubcenterChange(e, subcenterName)
                              }
                              checked={selectedSubcenters.includes(
                                subcenterName
                              )}
                            />
                            <label
                              htmlFor={`subcenter_${index}`}
                              className="ml-2"
                            >
                              {subcenterName}
                            </label>
                          </div>
                        )
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-none vector-img flex align-items-center justify-content-left ">
              <img
                src={vector_img}
                alt="vector_img"
                className="mr-2"
                style={{ marginTop: "40px" }}
              />
            </div>
            <div className="flex anm-dropdown flex-column flex-wrap align-items-left justify-content-left  font-bold   border-round">
              <div className="flex align-items-left justify-content-left">
                {t("TransfertoANM")}
              </div>
              <div className="card flex justify-content-center">
                <Dropdown
                  value={firstname}
                  options={anmOptions}
                  onChange={(e) => setfirstname(e.value)}
                  placeholder="Select ANM"
                  className="w-full md:w-14rem"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
